import { connect } from 'react-redux';

import RetentionCustomSequencePicker from '../../../components/retention/complex/RetentionCustomSequencePicker';
import {
  calculateCustomSequence,
  changeCustomSequence,
  changeDimensionType,
  setCustomSequenceFrom,
  setCustomSequenceTo,
  setCustomSequenceType,
  toggleCustomSequence,
} from '../../../actions/retention/retentionComplex';
import {
  getComplexCustomSequenceDimensions,
  getRetentionComplexCustomSequence,
  getRetentionComplexCustomSequenceType,
  getRetentionComplexDimensionType,
  isRetentionComplexCustomSequenceEnabled,
} from '../../../reducers/analyticsApp';

const mapStateToProps = (state) => ({
  enabled: isRetentionComplexCustomSequenceEnabled(state),
  sequence: getRetentionComplexCustomSequence(state),
  sequenceType: getRetentionComplexCustomSequenceType(state),
  sequenceDimensions: getComplexCustomSequenceDimensions(state),
  dimensionType: getRetentionComplexDimensionType(state),
});

const mapDispatchToProps = {
  onToggle: toggleCustomSequence,
  onSequenceChange: changeCustomSequence,
  onSequenceTypeChange: setCustomSequenceType,
  onSequenceFromChange: setCustomSequenceFrom,
  onSequenceToChange: setCustomSequenceTo,
  onCustomSequenceCalculate: calculateCustomSequence,
  onDimensionTypeChange: changeDimensionType,
};

export default connect(mapStateToProps, mapDispatchToProps)(RetentionCustomSequencePicker);
